import type { PortfolioMetrics as PortfolioMetricsType } from "../api/types";
import { usd } from "../lib/format";

interface Props {
  data: PortfolioMetricsType | undefined;
  /** Portfolio-level profit factor = total gross profit / total gross loss */
  portfolioPf?: number | null;
}

export function PortfolioMetrics({ data, portfolioPf }: Props) {
  const totalPnl = data?.total_pnl ?? 0;
  const todayPnl = data?.total_pnl_today ?? 0;
  const trades = data?.total_trades ?? 0;
  // const sleeves = data?.active_sleeves ?? 0;
  const sharpe = data?.portfolio_sharpe ?? null;
  const maxDD = data?.portfolio_max_dd ?? null;

  return (
    <div className="pcc-metrics">
      <MetricTile
        label="Total P&L"
        // sub="all-time · incl. retired"
        value={usd(totalPnl, { sign: true })}
        cls={totalPnl > 0 ? "good" : totalPnl < 0 ? "bad" : ""}
        wide
      />
      <MetricTile
        label="Today"
        value={usd(todayPnl, { sign: true })}
        cls={todayPnl > 0 ? "good" : todayPnl < 0 ? "bad" : ""}
      />
      <MetricTile
        label="Trades today"
        // sub="today"
        value={String(trades)}
      />
      {/* <MetricTile label="Sleeves" value={String(sleeves)} /> */}
      <MetricTile
        label="Sharpe"
        // sub="mean of sleeve Sharpes"
        value={sharpe !== null ? sharpe.toFixed(2) : "—"}
        cls={sharpe !== null ? (sharpe >= 1.0 ? "good" : sharpe >= 0.5 ? "warn" : "bad") : ""}
      />
      <MetricTile
        label="PF"
        value={portfolioPf !== null && portfolioPf !== undefined ? portfolioPf.toFixed(2) : "—"}
        cls={portfolioPf !== null && portfolioPf !== undefined ? (portfolioPf >= 2.0 ? "good" : portfolioPf >= 1.0 ? "warn" : "bad") : ""}
      />
      <MetricTile
        label="Max DD"
        // sub="equity peak-to-trough"
        value={maxDD !== null ? usd(maxDD) : "—"}
        cls="bad"
      />
    </div>
  );
}

function MetricTile({
  label,
  sub,
  value,
  cls = "",
  wide = false,
}: {
  label: string;
  /** Optional methodology/scope hint rendered under the label (e.g. "today"). */
  sub?: string;
  value: string;
  cls?: string;
  wide?: boolean;
}) {
  return (
    <div className={"pcc-metric" + (wide ? " wide" : "")}>
      <span className="pcc-metric-label">
        {label}
        {sub && <span className="muted" style={{ fontWeight: 400 }}> · {sub}</span>}
      </span>
      <span className={"pcc-metric-value" + (cls ? " " + cls : "")}>{value}</span>
    </div>
  );
}
